import { Component, EventEmitter, Output, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-generate-key-result',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './generate-key-result.component.html',
  styleUrl: './generate-key-result.component.scss',
})
export class GenerateKeyResultComponent {
  @Input() fileBlob!: Blob;
  @Output() close = new EventEmitter<void>();

  downloadKey() {
    const blob = new Blob([this.fileBlob]);
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'private_key.pem';
    a.click();

    window.URL.revokeObjectURL(url);
  }

  finish() {
    this.close.emit();
  }
}
